import {
  Alert,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { InstructionDialogTitle } from "./PlantProfileInstructionsDialog";
import { useTranslation } from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { FC, useState } from "react";
import WarningIcon from "@mui/icons-material/WarningAmber";
import XIcon from "@mui/icons-material/Close";

export const PlantProfileOverviewDialog: FC = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        size="small"
        color="inherit"
        aria-label={t(
          "components.categoryCollectionProfile.instructions.overviewTrigger"
        )}
        onClick={() => setOpen(true)}
      >
        <InfoOutlinedIcon />
      </IconButton>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className="flex justify-between items-baseline">
          <InstructionDialogTitle>
            {t("views.plantProfiles.title")}
          </InstructionDialogTitle>
          <IconButton
            aria-label={t("utils.actions.close")}
            onClick={() => setOpen(false)}
          >
            <XIcon fontSize="large" />
          </IconButton>
        </DialogTitle>

        <DialogContent className="flex flex-col gap-3">
          <Typography component="p">
            {t("components.categoryCollectionProfile.instructions.whatItIs")}
          </Typography>
          <Alert
            severity="warning"
            className="rounded-md"
            icon={<WarningIcon fontSize="small" />}
          >
            {t("components.categoryCollectionProfile.instructions.autoUpdate")}
          </Alert>
        </DialogContent>
      </Dialog>
    </>
  );
};
